import React, { PropsWithChildren } from "react";
//#region types
import { SimpleViewPanelProps } from "models/propTypes/panelsPropsTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import WidgetTitle from "../titles/widgetTitle";
import ErrorBoundary from "components/error/errorBoundary";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const SimpleViewPanel: React.FC<PropsWithChildren<SimpleViewPanelProps>> = (props) => {
  return (
    <Grid
      container
      direction={"column"}
      className={clsx(
        cssExports.simpleViewPanel,
        props.appearance === "sm" ? cssExports.viewPanelSm : cssExports.viewPanelMd
      )}
    >
      <WidgetTitle>{props.title}</WidgetTitle>
      <Grid item>
        <ErrorBoundary>{props.children}</ErrorBoundary>
      </Grid>
    </Grid>
  );
};

export default SimpleViewPanel;
